/* eslint-disable import/no-unused-modules */
import type { ReactNode } from 'react';
import { cn } from '@rocco/index';

interface ProposalSummaryRowProps {
    /** The label text displayed on the left side of the row. */
    label: string;
    /** Content displayed on the right side of the row. */
    children: ReactNode;
    /** Additional class names for the outer row container. */
    className?: string;
    /** Additional class names for the left label span. */
    leftClassName?: string;
    /** Additional class names for the right content span. */
    rightClassName?: string;
}

const TYPO_CLASS = {
    SUMMARY_TEXT:
        'font-display font-semibold text-base leading-none tracking-[-0.01em] text-[#929292]',
};

/** A two-column row used in proposal summary sections (e.g. subtotal, tax, total). */
const ProposalSummaryRow = ({
    label,
    children,
    className,
    leftClassName,
    rightClassName,
}: ProposalSummaryRowProps) => {
    return (
        <div
            className={cn(
                'flex flex-row justify-between',
                TYPO_CLASS.SUMMARY_TEXT,
                className
            )}
        >
            <span className={cn('pl-2', leftClassName)}>{label}</span>
            <span className={cn('pr-4 text-right', rightClassName)}>
                {children}
            </span>
        </div>
    );
};

export default ProposalSummaryRow;
